import { render, staticRenderFns } from "./ModalEditAddress.vue?vue&type=template&id=478b3f50&scoped=true"
import script from "./ModalEditAddress.vue?vue&type=script&lang=js"
export * from "./ModalEditAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478b3f50",
  null
  
)

export default component.exports